import { Component, input, output } from '@angular/core';
import { RidSfxDirective } from '../../directives/rid-sfx.directive';

@Component({
  selector: 'rid-dice-slot',
  imports: [RidSfxDirective],
  templateUrl: './rid-dice-slot.html',
})
export class RidDiceSlot {
  color = input.required<'ORANGE' | 'BLUE' | 'EMERALD'>();
  value = input<number | string | undefined>(undefined);
  togglable = input.required<boolean>();

  toggled = output<void>();
}
